module.exports = __webpack_public_path__ + "img/88c6307.png";